import { GeneralType } from '../../../../types';

export const GENERAL_TYPES: GeneralType[] = [
  'light',
  'dark',
  'gray',
  'primary',
  'secondary',
  'warning',
  'success',
  'danger'
];
